import React from "react";

const Nullifier = ({
  onClick,
  className = "",
  ariaLabel = "Limpiar valor",
  title = "Limpiar valor",
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`nullifier_button ${className}`.trim()}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
    >
      <span className="nullifier_button_cross" />
    </button>
  );
};

export default Nullifier;
